<template>
	<div class="box">
		<div class="null-page" v-show="yes"></div>
		
		<div class="my-point" v-loading="loading">
			<div class="member-point">
				<div class="title">我的积分</div>
				<div class="point-content">
                    <div class="num">{{ memberPoint.point ? Math.ceil(memberPoint.point) : 0 }}</div>
                    <div class="transferPoint" @click="openTransferDialog">积分转移</div>
                </div>
			</div>
			<div class="detail">
				<el-table :data="pointList" border>
					<el-table-column prop="type_name" label="来源" width="150"></el-table-column>
					<el-table-column prop="pointNum" label="积分" width="150"></el-table-column>
					<el-table-column prop="remark" label="详细说明"></el-table-column>
					<el-table-column prop="time" label="时间" width="180"></el-table-column>
				</el-table>
			</div>
			<div class="pager">
				<el-pagination 
					background 
					:pager-count="5" 
					:total="total" 
					prev-text="上一页" 
					next-text="下一页" 
					:current-page.sync="pointInfo.page" 
					:page-size.sync="pointInfo.page_size" 
					@size-change="handlePageSizeChange" 
					@current-change="handleCurrentPageChange" 
					hide-on-single-page
				></el-pagination>
			</div>
		</div>

		<!-- 积分转移弹窗 -->
		<el-dialog title="积分转移" :visible.sync="transferDialogVisible" width="500px">
			<el-form :model="transferForm" label-width="100px">
				<el-form-item label="转移积分数量">
					<el-input v-model.number="transferForm.point" type="number" min="1" placeholder="请输入要转移的积分数量"></el-input>
				</el-form-item>
				<el-form-item label="目标账户">
					<el-select v-model="transferForm.member_id" placeholder="请选择目标账户" style="width: 100%">
						<el-option 
							v-for="account in accountList" 
							:key="account.member_id" 
							:label="account.nickname + ' (' + account.mobile + ')'" 
							:value="account.member_id"
						></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="transferDialogVisible = false">取消</el-button>
				<el-button type="primary" @click="confirmTransfer">确认</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
    import { pointInfo, pointList, transferPoint } from "@/api/member/my_point"
    import { multiaccount } from "@/api/member/index"
    import { mapGetters } from 'vuex'
    export default {
        name: "my_point",
        components: {},
        data: () => {
            return {
                pointInfo: {
                    page: 1,
                    page_size: 10,
                    account_type: "point"
                },
                pointList: [],
                memberPoint: {
                    point: 0
                },
                total: 0,
                loading: true,
			    yes: true,
                // 积分转移相关
                transferDialogVisible: false,
                transferForm: {
                    point: '',
                    member_id: ''
                },
                accountList: []
            }
        },
        computed: {
            ...mapGetters(['member'])
        },
        created() {
            this.getPointInfo(), this.getpointList()
        },
		mounted() {
			let self = this;
			setTimeout(function() {
				self.yes = false
			}, 300)
		},
        methods: {
            getPointInfo() {
                pointInfo({ account_type: this.pointInfo.account_type })
                    .then(res => {
                        if (res.code == 0 && res.data) {
                            this.memberPoint = res.data
                        }
                        this.loading = false
                    })
                    .catch(err => {
                        this.loading = false
                        this.$message.error(err.message)
                    })
            },
            getpointList() {
                pointList(this.pointInfo)
                    .then(res => {
                        if (res.code == 0 && res.data) {
                            this.pointList = res.data.list
                            this.total = res.data.count
                            this.pointList.forEach(item => {
                                item.time = this.$util.timeStampTurnTime(item.create_time)
                                item.pointNum = item.account_data > 0 ? "+" + parseInt(item.account_data) : parseInt(item.account_data)
                            })
                        }
                    })
                    .catch(err => {
                        this.$message.error(err.message)
                    })
            },
            handlePageSizeChange(num) {
                this.pointInfo.page_size = num
                this.getpointList()
            },
            handleCurrentPageChange(page) {
                this.pointInfo.page = page
                this.getpointList()
            },
            // 获取账户列表
            getAccountList() {
                multiaccount()
                    .then(res => {
                        if (res.code == 0 && res.data && res.data.group_list) {
                            // 过滤掉当前登录账户和禁用账户
                            this.accountList = res.data.group_list.filter(account => {
                                return !account.is_current_member && account.status == 1
                            })
                        }
                    })
                    .catch(err => {
                        this.$message.error(err.message)
                    })
            },
            // 打开积分转移弹窗
            openTransferDialog() {
                // 重置表单
                this.transferForm = {
                    point: '',
                    member_id: ''
                }
                // 获取账户列表
                this.getAccountList()
                // 显示弹窗
                this.transferDialogVisible = true
            },
            // 确认积分转移
            confirmTransfer() {
                if (!this.transferForm.point || this.transferForm.point <= 0) {
                    this.$message.error('请输入有效的积分数量')
                    return
                }
                if (!this.transferForm.member_id) {
                    this.$message.error('请选择目标账户')
                    return
                }
                if (this.transferForm.point > this.memberPoint.point) {
                    this.$message.error('积分数量不足')
                    return
                }

                transferPoint(this.transferForm)
                    .then(res => {
                        if (res.code == 0) {
                            this.$message.success('积分转移成功')
                            this.transferDialogVisible = false
                            // 刷新积分信息
                            this.getPointInfo()
                            this.getpointList()
                        } else {
                            this.$message.error(res.message || '积分转移失败')
                        }
                    })
                    .catch(err => {
                        this.$message.error(err.message || '积分转移失败')
                    })
            }
        }
    }
</script>
<style lang="scss" scoped>
	.box {
		width: 100%;
		position: relative;
	}
	
	.null-page {
		width: 100%;
		height: 730px;
		background-color: #FFFFFF;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 9;
	}
	
    .my-point {
        background: #ffffff;
        padding: 20px;
        .member-point {
            font-size: $ns-font-size-base;
            font-weight: 600;
            margin-bottom: 10px;
            .num {
                font-size: 30px;
                font-weight: 600;
            }
            .point-content{
                display: flex;
                align-items: baseline;
                gap: 12px;
            }
            .transferPoint{
                font-size: $ns-font-size-base;
                font-weight: bold;
                color: #ff547b;
                cursor: pointer;
            }
        }
        .page {
            display: flex;
            justify-content: center;
            align-content: center;
            padding-top: 20px;
        }
    }
</style>
